export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOGIN_ERROR_CLEAR = "LOGIN_ERROR_CLEAR";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST"; 